import { render, staticRenderFns } from "./DialogGeneric.vue?vue&type=template&id=1deefdcc&scoped=true&lang=pug"
import script from "./DialogGeneric.vue?vue&type=script&lang=ts"
export * from "./DialogGeneric.vue?vue&type=script&lang=ts"
import style0 from "./DialogGeneric.vue?vue&type=style&index=0&id=1deefdcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deefdcc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LsIcon: require('/workspace/packages/sharedUI/src/Icon/Icon.vue').default,LsChip: require('/workspace/packages/sharedUI/src/Chip/Chip.vue').default,LsPopover: require('/workspace/packages/sharedUI/src/Popover/Popover.vue').default,LsButton: require('/workspace/packages/sharedUI/src/Button/Button.vue').default,LsButtonWrapper: require('/workspace/packages/sharedUI/src/Button/ButtonWrapper/ButtonWrapper.vue').default})
